import { render, staticRenderFns } from "./WebAR.vue?vue&type=template&id=000901c8&"
import script from "./WebAR.vue?vue&type=script&lang=js&"
export * from "./WebAR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports